<iframe *ngIf="_data"
  [id]="_data.id"
  [title]="_data.title"
  [width]="iframeDimensions.width"
  [height]="iframeDimensions.height"
  [src]="urlDocument"
  class="iframegedviewer">
</iframe>
